// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3349":"43595ec1","4006":"6f0094c1"}[chunkId] + ".chunk.css";
};